import { load } from './loader';

const loadJQuery = () => load([process.env.REACT_APP_JQUERY_URL]);

export default loadJQuery;
